<div class="dropstart">
  <button
    class="btn btn-link"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    <svg-icon
      src="../../../assets/images/icons/user-profile.svg"
      [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
    ></svg-icon>
  </button>
  <ul class="dropdown-menu">
    <li>
      <button class="dropdown-item" (click)="signOut()">
        {{ signOutItem.name | msg | async }}
      </button>
    </li>
  </ul>
</div>
